import { SVGProps } from "react";

interface ArrowIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  direction?:
    | "up"
    | "down"
    | "left"
    | "right"
    | "up-right"
    | "up-left"
    | "down-right"
    | "down-left";
}

export default function ArrowIcon({
  size = 16,
  className = "",
  direction = "right",
  ...props
}: ArrowIconProps) {
  const getRotation = () => {
    switch (direction) {
      case "up":
        return "rotate-[-90deg]";
      case "down":
        return "rotate-90";
      case "left":
        return "rotate-180";
      case "right":
        return "rotate-0";
      case "up-right":
        return "rotate-[-45deg]";
      case "up-left":
        return "rotate-[-135deg]";
      case "down-right":
        return "rotate-45";
      case "down-left":
        return "rotate-[135deg]";
      default:
        return "rotate-0";
    }
  };

  const rotationClass = getRotation();
  const combinedClassName = `transition-transform duration-200 ease-in-out ${rotationClass} ${className}`;

  return (
    <svg
      width={size}
      height={size}
      className={combinedClassName}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14 5l7 7m0 0l-7 7m7-7H3"
      />
    </svg>
  );
}
